import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { Paginated, PaginationQuery } from "../../types";
import useApi, { buildUrl } from "../api";
import { CustomError } from "../errors";
import { ProcessingRequestFinalItem } from "../processingRequestFinalItem/types";

export interface FileInfo {
  data: string;
  contentType: string;
}

const useFinalItemApi = () => {
  const baseurl = "/final_items";
  const requestUrl = "/processing_requests";

  const api = useApi();

  const useProcessingRequestFinalItems = useCallback(
    (query: PaginationQuery, requestID: string) => {
      const url = buildUrl(requestUrl + "/" + requestID + baseurl, query);
      const result = useQuery<Paginated<ProcessingRequestFinalItem>, CustomError>({
        queryKey: [url],
        queryFn: ({ signal }) => api.get<Paginated<ProcessingRequestFinalItem>>({ url, signal }),
      });
      return { ...result, error: result.error ?? undefined };
    },
    [api]
  );

  // const createFinalItem = useCallback(
  //   async (pr: InsertProcessingRequestFinalItem, requestID: string) => {
  //     const data = await api.post<InsertProcessingRequestFinalItem, string>(requestUrl + "/" + requestID + baseurl, pr);
  //     api.mutateCache([requestUrl + "/" + requestID + baseurl]);
  //     return data;
  //   },
  //   [api]
  // );

  // const updateFinalItem = useCallback(
  //   async (pr: UpdateProcessingRequestFinalItem, finalItemID: string, requestID: string) => {
  //     const data = await api.put<UpdateProcessingRequestFinalItem>(
  //       `${requestUrl}/${requestID + baseurl}/${finalItemID}`,
  //       pr
  //     );
  //     api.mutateCache([requestUrl + "/" + requestID + baseurl]);
  //     return data;
  //   },
  //   [api]
  // );

  // const deleteFinalItem = useCallback(
  //   async (finalItemID: string, requestID: string) => {
  //     const data = await api.del(`${baseurl}/${finalItemID}`);
  //     api.mutateCache([requestUrl + "/" + requestID + baseurl]);
  //     return data;
  //   },
  //   [api]
  // );

  return {
    useProcessingRequestFinalItems,
    // createFinalItem,
    // deleteFinalItem,
    // updateFinalItem,
  };
};

export default useFinalItemApi;
